module.exports = "/_next/static/images/8ee66e8bcafec5b2c9cb2f115a47e699-hero-100m-desktop.jpg.webp";